import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import OrderData from "./OrderRequestsModel/OrderData"
import SaveOrder from "./OrderRequestsModel/SaveOrder"
import { FinishData } from "../../components/OrderRequests/OrderFinish"

export default function OrderSubmitObservable(params: SaveOrder): Observable<OrderData> {
  const requestBody: string = JSON.stringify(params)

  return ObservableFromFetch<OrderData>("/workforceorder/saveorder", requestBody)
}

export function OrderFinishObservable(data: FinishData) {
  const requestBody: string = JSON.stringify(data)

  return ObservableFromFetch<string>("WorkforceOrder/FinishOrder", requestBody)
}